export default [
  {
    component: 'div',
    class: 'row',
    children: [
      {
        name: 'clientNumber',
        label: 'Client number'
      }
    ]
  },
]